// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2TTy7","head":"Table_head__27hlJ","col":"Table_col__2eLzU"};